const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_ADVERTISEMENT = "advertisement";
const SERVICE_ANALYTICS_STORAGE = "analytics_storage";
const SERVICE_AD_STORAGE = "ad_storage";
const SERVICE_AD_USER_DATA = "ad_user_data";
const SERVICE_AD_PERSONALIZATION = "ad_personalization";

export {
  CAT_NECESSARY,
  CAT_ANALYTICS,
  CAT_ADVERTISEMENT,
  SERVICE_ANALYTICS_STORAGE,
  SERVICE_AD_STORAGE,
  SERVICE_AD_USER_DATA,
  SERVICE_AD_PERSONALIZATION,
};
